export var AuthErrorStrings;

(function (AuthErrorStrings) {
  AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
  AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
  AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
  AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
  AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
  AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
  AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
  AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
  AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
  AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
})(AuthErrorStrings || (AuthErrorStrings = {}));